import { doRequest as baseDoRequest } from './base'
import { doRequest, REQUEST_METHODS } from './myBase'

export const getCustomerDetails = async (): Promise<CustomerDetailsResponse> => {
  return await doRequest(REQUEST_METHODS.GET, '/api/customers/details')
}

export const updateDetails = async (
  details: CustomerDetailsRequest
): Promise<UpdateCustomerDetailsResponse> => {
  return await doRequest(REQUEST_METHODS.PATCH, '/api/customers', details)
}

export const getPrimaryCardDetails = async (): Promise<PaymentCardResponse> => {
  return await baseDoRequest(REQUEST_METHODS.GET, '/api/customers/primary_card')
}

export const requestEmailChange = async (newEmail: string): Promise<ApiNoContentResponse> => {
  return await doRequest(REQUEST_METHODS.POST, '/api/customers/change_email', {
    new_email: newEmail
  })
}

export const resendChangeEmailInstructions = async (): Promise<ApiNoContentResponse> => {
  return await doRequest(REQUEST_METHODS.POST, '/api/customers/resend_change_email_instructions')
}

export const verifyEmailChange = async (token: string): Promise<VerifyEmailChangeResponse> => {
  return await doRequest(REQUEST_METHODS.POST, '/api/customers/verify_change_email', { token })
}

export const verifyCustomerAccount = async (token: string): Promise<VerifyAccountResponse> => {
  return await doRequest(REQUEST_METHODS.POST, `/api/customers/verify/${token}`)
}

export default {
  updateDetails,
  getPrimaryCardDetails,
  requestEmailChange,
  resendChangeEmailInstructions,
  verifyEmailChange,
  getCustomerDetails,
  verifyCustomerAccount
}
